// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconHeaderMenu: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path d="M17,16 L1,16 C0.433928694,16 0,16.4499995 0,17 C0,17.5500005 0.433928694,18 1,18 L17,18 C17.5660719,18 18,17.5500005 18,17 C18,16.4499995 17.5660719,16 17,16 Z M17,0 L1,0 C0.433928694,0 0,0.449999491 0,1 C0,1.47499975 0.433928694,2 1,2 L17,2 C17.5660719,2 18,1.55000051 18,1 C18,0.525000254 17.5660719,0 17,0 Z M17,8 L1,8 C0.433928694,8 0,8.45000013 0,9 C0,9.55000051 0.433928694,10 1,10 L17,10 C17.5660719,10 18,9.55000051 18,9 C18,8.44999949 17.5660719,8 17,8 Z" />
        </svg>
    );
};

export default React.memo(IconHeaderMenu);
